import Experience from './Experience/Experience.js'
import ScrollCamera from './Experience/Utils/ScrollCamera.js'
import OilFlow from './OilFlow.js'
import LidScene from './LidScene.js'
import TipScenes from './TipScenes.js'
import CandleViewer from './CandleViewer.js'

// ── Loading screen ──────────────────────────────────────────
const loader    = document.getElementById('loader')
const loaderBar = document.querySelector('.loader-bar')

const experience = new Experience(document.querySelector('canvas.webgl'))

// Progress bar
experience.resources.on('progress', (ratio) => {
    loaderBar.style.width = `${(ratio * 100).toFixed(0)}%`
})

// All 3D assets ready
experience.resources.on('ready', () => {
    // Fill bar to 100%, then fade loader out
    loaderBar.style.width = '100%'

    setTimeout(() => {
        loader.classList.add('hidden')
    }, 600)

    // Initialise all interactive systems
    new ScrollCamera()
    new OilFlow()
    new LidScene()
    new TipScenes()
    new CandleViewer()
})
